import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

export const NOTIFICATION_TAG_TYPES = {
  ALERT: "alert",
  SIGNAL: "signal",
  BUY: "buy",
  SELL: "sell",
  SCENARIO: "scenario",
  DEMAND: "demand",
  SUPPLY: "supply",
  INSIDER: "insider",
  INSIDER_RECOMMENDATION: "insiderRecommendation"
};

const NotificationTag = ({ type, text, prefix }) => {
  return (
    <div
      className={classNames("px-1.5 py-0.5", {
        "text-black bg-gray-4 text-xs.1 rounded":
          type === NOTIFICATION_TAG_TYPES.ALERT,
        "text-white bg-green text-xs.1 rounded": [
          NOTIFICATION_TAG_TYPES.BUY,
          NOTIFICATION_TAG_TYPES.DEMAND
        ].includes(type),
        "text-white bg-red-2 text-xs.1 rounded": [
          NOTIFICATION_TAG_TYPES.SELL,
          NOTIFICATION_TAG_TYPES.SUPPLY
        ].includes(type),
        "text-black bg-yellow text-xs.1 rounded": [
          NOTIFICATION_TAG_TYPES.SIGNAL,
          NOTIFICATION_TAG_TYPES.SCENARIO
        ].includes(type),
        "text-yellow bg-black text-xs.4 rounded-0.5":
          type === NOTIFICATION_TAG_TYPES.INSIDER,
        "text-black bg-green-2 text-xs.1 rounded":
          type === NOTIFICATION_TAG_TYPES.INSIDER_RECOMMENDATION
      })}
    >
      {prefix ? <span className={"text-black-6"}>{prefix}</span> : null}
      <span className={"font-bold uppercase"}>{text}</span>
    </div>
  );
};

NotificationTag.propTypes = {
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TAG_TYPES)),
  text: PropTypes.string.isRequired
};

export default NotificationTag;
